import { render, staticRenderFns } from "./CheckboxWithQuantity.vue?vue&type=template&id=6b38e545&scoped=true&"
import script from "./CheckboxWithQuantity.vue?vue&type=script&lang=js&"
export * from "./CheckboxWithQuantity.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxWithQuantity.vue?vue&type=style&index=0&id=6b38e545&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b38e545",
  null
  
)

export default component.exports